import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

interface MetadataRowProps {
  icon: LucideIcon;
  label: string;
  children: ReactNode;
}

export function MetadataRow({ icon: Icon, label, children }: MetadataRowProps) {
  return (
    <div className="flex items-center gap-1.5">
      <Icon className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      <span className="text-xs text-muted-foreground">{label}:</span>
      {children}
    </div>
  );
}
